// import { useState, useEffect } from "react";

// export function Products() {
//   const [currentProductIndex, setCurrentProductIndex] = useState(0);

//   const products = [
//     {
//       name: "Dell Inspiron 15",
//       price: 2800000, // UGX
//       description: "Powerful and reliable laptop for everyday tasks.",
//       img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Razer BlackWidow V4",
//       price: 680000, // UGX
//       description: "Mechanical gaming keyboard with RGB lighting.",
//       img: "https://images.unsplash.com/photo-1625079737710-3c7dfc915b14?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Logitech MX Master 3",
//       price: 370000, // UGX
//       description: "Ergonomic and precise mouse for productivity.",
//       img: "https://images.unsplash.com/photo-1611078489603-4f42a96d7f4b?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Samsung T7 Portable SSD",
//       price: 560000, // UGX
//       description: "Fast and compact 1TB external solid-state drive.",
//       img: "https://images.unsplash.com/photo-1616765684238-0e77a46bb5a7?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "BenQ 27-inch Monitor",
//       price: 1110000, // UGX
//       description: "Full HD monitor with eye-care technology.",
//       img: "https://images.unsplash.com/photo-1587202372775-f5b4e9db8693?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "SteelSeries Arctis 7",
//       price: 560000, // UGX
//       description: "Wireless gaming headset with crystal-clear audio.",
//       img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?auto=format&fit=crop&w=800&q=80",
//     },
//   ];

//   const nextProduct = () => {
//     setCurrentProductIndex((prev) => (prev + 1) % products.length);
//   };

//   const prevProduct = () => {
//     setCurrentProductIndex(
//       (prev) => (prev - 1 + products.length) % products.length
//     );
//   };

//   useEffect(() => {
//     const interval = setInterval(nextProduct, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <section
//       id="products"
//       className="py-16 px-4 sm:px-6 bg-red-400"
//       style={{ minHeight: "calc(100vh - 60px)" }}
//     >
//       <h3 className="text-3xl font-bold text-center mb-8">Featured Products</h3>
//       <div className="relative max-w-6xl mx-auto">
//         {/* Carousel */}
//         <div>
//           <div
//             className="flex transition-transform duration-500 ease-in-out"
//             style={{
//               transform: `translateX(-${currentProductIndex * (100 / 3)}%)`,
//             }}
//           >
//             {products.map((p, i) => (
//               <div
//                 key={i}
//                 // className="flex-shrink-0 w-full sm:w-1/2 lg:w-1/3 px-2"
//                 className="bg-yellow-400"
//               >
//                 {/* <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
//                   <img
//                     src={p.img}
//                     alt={p.name}
//                     className="w-full h-64 sm:h-48 lg:h-56 object-cover"
//                   />
//                   <div className="p-6 text-center">
//                     <h4 className="text-xl font-semibold mb-1">{p.name}</h4>
//                     <p className="text-gray-500 text-sm sm:text-base">
//                       {p.description}
//                     </p>
//                     <p className="text-2xl font-bold text-blue-600 mt-3">
//                       {p.price}
//                     </p>
//                     <button className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
//                       Add to Cart
//                     </button>
//                   </div>
//                 </div> */}
//                 <div className="bg-white rounded-2xl shadow-lg">
//                   <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
//                     {/* <img
//                       src={p.img}
//                       alt={p.name}
//                       className="w-full h-64 sm:h-48 lg:h-56 object-cover"
//                     /> */}
//                     <div className="p-6 text-center">
//                       <h4 className="text-xl font-semibold mb-1">{p.name}</h4>
//                       <p className="text-gray-500 text-sm sm:text-base">
//                         {p.description}
//                       </p>
//                       <p className="text-2xl font-bold text-blue-600 mt-3">
//                         {p.price}
//                       </p>
//                       <button className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
//                         Add to Cart
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         {/* Left / Right Arrows */}
//         <button
//           onClick={prevProduct}
//           className="absolute top-1/2 -translate-y-1/2 left-0 p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 text-blue-600"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-6 w-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>
//         <button
//           onClick={nextProduct}
//           className="absolute top-1/2 -translate-y-1/2 right-0 p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 text-blue-600"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-6 w-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9 5l7 7-7 7"
//             />
//           </svg>
//         </button>

//         {/* Dots */}
//         <div className="flex justify-center mt-6 space-x-2">
//           {products.map((_, i) => (
//             <span
//               key={i}
//               onClick={() => setCurrentProductIndex(i)}
//               className={`block w-3 h-3 rounded-full cursor-pointer transition-colors duration-300 ${
//                 i === currentProductIndex
//                   ? "bg-blue-600"
//                   : "bg-gray-300 hover:bg-gray-400"
//               }`}
//             ></span>
//           ))}
//         </div>
//       </div>
//       ;
//     </section>
//   );
// }

// import { useState, useEffect } from "react";

// export function Products() {
//   const [currentProductIndex, setCurrentProductIndex] = useState(0);

//   const products = [
//     {
//       name: "Dell Inspiron 15",
//       price: 2800000,
//       description: "Powerful and reliable laptop for everyday tasks.",
//       img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Razer BlackWidow V4",
//       price: 680000,
//       description: "Mechanical gaming keyboard with RGB lighting.",
//       img: "https://images.unsplash.com/photo-1625079737710-3c7dfc915b14?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Logitech MX Master 3",
//       price: 370000,
//       description: "Ergonomic and precise mouse for productivity.",
//       img: "https://images.unsplash.com/photo-1611078489603-4f42a96d7f4b?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Samsung T7 Portable SSD",
//       price: 560000,
//       description: "Fast and compact 1TB external solid-state drive.",
//       img: "https://images.unsplash.com/photo-1616765684238-0e77a46bb5a7?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "BenQ 27-inch Monitor",
//       price: 1110000,
//       description: "Full HD monitor with eye-care technology.",
//       img: "https://images.unsplash.com/photo-1587202372775-f5b4e9db8693?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "SteelSeries Arctis 7",
//       price: 560000,
//       description: "Wireless gaming headset with crystal-clear audio.",
//       img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?auto=format&fit=crop&w=800&q=80",
//     },
//   ];

//   const nextProduct = () => {
//     setCurrentProductIndex((prev) => (prev + 1) % products.length);
//   };

//   const prevProduct = () => {
//     setCurrentProductIndex(
//       (prev) => (prev - 1 + products.length) % products.length
//     );
//   };

//   useEffect(() => {
//     const interval = setInterval(nextProduct, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <section id="products" className="py-16 px-4 sm:px-6 bg-gray-50">
//       <h3 className="text-3xl font-bold text-center mb-12">
//         Featured Products
//       </h3>

//       <div className="relative max-w-4xl mx-auto">
//         {/* Carousel */}
//         <div className="overflow-hidden">
//           <div
//             className="flex transition-transform duration-500 ease-in-out"
//             style={{
//               transform: `translateX(-${currentProductIndex * 100}%)`,
//             }}
//           >
//             {products.map((p, i) => (
//               <div key={i} className="flex-shrink-0 w-full px-2">
//                 <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
//                   <img
//                     src={p.img}
//                     alt={p.name}
//                     className="w-full h-64 object-cover"
//                   />
//                   <div className="p-6 text-center">
//                     <h4 className="text-xl font-semibold mb-1">{p.name}</h4>
//                     <p className="text-gray-500 text-sm">{p.description}</p>
//                     <p className="text-2xl font-bold text-blue-600 mt-3">
//                       {p.price}
//                     </p>
//                     <button className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
//                       Add to Cart
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Left / Right Arrows */}
//         <button
//           onClick={prevProduct}
//           className="absolute top-1/2 -translate-y-1/2 left-0 p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 text-blue-600"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-6 w-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>
//         <button
//           onClick={nextProduct}
//           className="absolute top-1/2 -translate-y-1/2 right-0 p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 text-blue-600"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-6 w-6"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9 5l7 7-7 7"
//             />
//           </svg>
//         </button>
//       </div>

//       {/* Dots */}
//       <div className="flex justify-center mt-6 space-x-2">
//         {products.map((_, i) => (
//           <span
//             key={i}
//             onClick={() => setCurrentProductIndex(i)}
//             className={`block w-3 h-3 rounded-full cursor-pointer transition-colors duration-300 ${
//               i === currentProductIndex
//                 ? "bg-blue-600"
//                 : "bg-gray-300 hover:bg-gray-400"
//             }`}
//           ></span>
//         ))}
//       </div>
//     </section>
//   );
// }

// // Products.tsx
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaLaptop,
//   FaNetworkWired,
//   FaServer,
//   FaCode,
//   FaGlobe,
//   FaClipboardList,
//   FaPenFancy,
//   FaPrint,
//   FaChevronLeft,
//   FaChevronRight,
// } from "react-icons/fa";

// export function Products() {
//   const kevmarkProducts = [
//     {
//       name: "Preventive Maintenance & Repair",
//       price: "From UGX 150,000",
//       description:
//         "IT troubleshooting, diagnostics, and repair for laptops, desktops, printers, and more.",
//       icon: <FaLaptop className="w-10 h-10 text-blue-600" />,
//       img: "https://www.techly.com/media/catalog/product/2/0/20-56_2.jpg",
//     },
//     {
//       name: "LAN & Data Cabling",
//       price: "From UGX 1,200,000",
//       description:
//         "Design, supply, and installation of LAN, voice, data, and power cabling systems.",
//       icon: <FaNetworkWired className="w-10 h-10 text-indigo-600" />,
//       img: "https://media.startech.com/cms/products/gallery_large/n6patch15bl10pk.main.jpg",
//     },
//     {
//       name: "Hardware Supply & Install",
//       price: "From UGX 2,500,000",
//       description:
//         "Servers, desktops, printers, CCTV, UPS, access control systems – supply & setup.",
//       icon: <FaServer className="w-10 h-10 text-teal-600" />,
//       img: "https://www.rbs-usa.com/img/uploads/image/All-hardware.png",
//     },
//     {
//       name: "Software & Training",
//       price: "From UGX 800,000",
//       description:
//         "Software supply, installation, integration, user training, and ongoing support.",
//       icon: <FaCode className="w-10 h-10 text-green-600" />,
//       img: "https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Website Design & Hosting",
//       price: "From UGX 1,200,000",
//       description:
//         "Custom website design, domain registration, hosting, and maintenance.",
//       icon: <FaGlobe className="w-10 h-10 text-purple-600" />,
//       img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Stationery & Office Supplies",
//       price: "From UGX 5,000",
//       description:
//         "Paper, inks, toners, pens, notebooks, filing – everything at great prices.",
//       icon: <FaClipboardList className="w-10 h-10 text-orange-600" />,
//       img: "https://m.media-amazon.com/images/I/81K5l37CaGL.jpg",
//     },
//     {
//       name: "Branding & Design",
//       price: "From UGX 350,000",
//       description:
//         "Logo design, business cards, banners – custom branding for SMEs and corporates.",
//       icon: <FaPenFancy className="w-10 h-10 text-pink-600" />,
//       img: "https://media.licdn.com/dms/image/v2/D4E12AQE5h7fOUJoqnQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1690827620760?e=2147483647&t=-fWaTqvuEGfAllY3HAgLAEpPhjMWKH_zMLdps3IzZfM&v=beta",
//     },
//     {
//       name: "Industrial Printing",
//       price: "From UGX 15,000",
//       description:
//         "Flyers, brochures, posters, books – e-commerce platform + 5% sponsor discount.",
//       icon: <FaPrint className="w-10 h-10 text-red-600" />,
//       img: "https://image.made-in-china.com/2f0j00odjthYMCySqO/3-2m-Advertisement-PVC-Banner-Large-Format-Printer.webp",
//     },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);

//   const next = () => setCurrentIndex((i) => (i + 1) % kevmarkProducts.length);
//   const prev = () =>
//     setCurrentIndex(
//       (i) => (i - 1 + kevmarkProducts.length) % kevmarkProducts.length
//     );

//   useEffect(() => {
//     const id = setInterval(next, 4500);
//     return () => clearInterval(id);
//   }, []);

//   return (
//     <section
//       id="products"
//       className="py-16 px-6 bg-gradient-to-b from-gray-50 to-white"
//       style={{ minHeight: "calc(100vh - 80px)" }}
//     >
//       {/* Title */}
//       <div className="text-center mb-14">
//         <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
//           Our Products & Solutions
//         </h2>
//         <p className="mt-3 text-lg text-gray-600 max-w-2xl mx-auto">
//           Trusted by schools, businesses, and government since 2008.
//         </p>
//       </div>

//       {/* Carousel */}
//       <div className="relative max-w-7xl mx-auto overflow-hidden">
//         <div
//           className="flex transition-transform duration-600 ease-in-out"
//           style={{ transform: `translateX(-${currentIndex * 33.333}%)` }}
//         >
//           {kevmarkProducts.map((p, i) => (
//             <div key={i} className="flex-shrink-0 w-1/3 px-4">
//               <div className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden">
//                 {/* Image */}
//                 <div className="relative h-48 overflow-hidden">
//                   <img
//                     src={p.img}
//                     alt={p.name}
//                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition" />
//                 </div>

//                 {/* Content */}
//                 <div className="p-6 text-center">
//                   <div className="flex justify-center mb-3">{p.icon}</div>
//                   <h3 className="text-xl font-semibold text-gray-800">
//                     {p.name}
//                   </h3>
//                   <p className="mt-2 text-sm text-gray-600 line-clamp-2">
//                     {p.description}
//                   </p>
//                   {/* <p className="mt-3 text-lg font-bold text-blue-700">
//                     {p.price}
//                   </p>
//                   <button className="mt-4 w-full bg-blue-700 text-white py-2.5 rounded-lg font-medium hover:bg-blue-800 transition">
//                     Get Quote
//                   </button> */}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Arrows */}
//         <button
//           onClick={prev}
//           className="absolute left-2 top-1/2 -translate-y-1/2 p-2.5 bg-white rounded-full shadow-lg hover:shadow-xl transition"
//           aria-label="Previous product"
//         >
//           <FaChevronLeft className="w-5 h-5 text-blue-700" />
//         </button>
//         <button
//           onClick={next}
//           className="absolute right-2 top-1/2 -translate-y-1/2 p-2.5 bg-white rounded-full shadow-lg hover:shadow-xl transition"
//           aria-label="Next product"
//         >
//           <FaChevronRight className="w-5 h-5 text-blue-700" />
//         </button>
//       </div>

//       {/* Dots */}
//       <div className="flex justify-center mt-8 space-x-2">
//         {kevmarkProducts.map((_, i) => (
//           <button
//             key={i}
//             onClick={() => setCurrentIndex(i)}
//             className={`w-2.5 h-2.5 rounded-full transition ${
//               i === currentIndex
//                 ? "bg-blue-700 w-8"
//                 : "bg-gray-300 hover:bg-gray-400"
//             }`}
//             aria-label={`Go to slide ${i + 1}`}
//           />
//         ))}
//       </div>

//       {/* View All CTA */}
//       <div className="text-center mt-12">
//         <Link
//           to="/all-products"
//           className="inline-flex items-center gap-2 bg-blue-700 text-white px-7 py-3.5 rounded-lg font-semibold shadow hover:bg-blue-800 hover:shadow-lg transition"
//         >
//           View All Products
//           <FaChevronRight className="w-4 h-4" />
//         </Link>
//       </div>
//     </section>
//   );
// }

// Products.tsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaLaptop,
  FaNetworkWired,
  FaServer,
  FaCode,
  FaGlobe,
  FaClipboardList,
  FaPenFancy,
  FaPrint,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

export function Products() {
  const kevmarkProducts = [
    {
      name: "Preventive Maintenance & Repair",
      price: "From UGX 150,000",
      description:
        "IT troubleshooting, diagnostics, and repair for laptops, desktops, printers, and more.",
      icon: <FaLaptop className="w-10 h-10 text-blue-600" />,
      img: "https://www.techly.com/media/catalog/product/2/0/20-56_2.jpg",
    },
    {
      name: "LAN & Data Cabling",
      price: "From UGX 1,200,000",
      description:
        "Design, supply, and installation of LAN, voice, data, and power cabling systems.",
      icon: <FaNetworkWired className="w-10 h-10 text-indigo-600" />,
      img: "https://media.startech.com/cms/products/gallery_large/n6patch15bl10pk.main.jpg",
    },
    {
      name: "Hardware Supply & Install",
      price: "From UGX 2,500,000",
      description:
        "Servers, desktops, printers, CCTV, UPS, access control systems – supply & setup.",
      icon: <FaServer className="w-10 h-10 text-teal-600" />,
      img: "https://www.rbs-usa.com/img/uploads/image/All-hardware.png",
    },
    {
      name: "Software & Training",
      price: "From UGX 800,000",
      description:
        "Software supply, installation, integration, user training, and ongoing support.",
      icon: <FaCode className="w-10 h-10 text-green-600" />,
      img: "https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?auto=format&fit=crop&w=800&q=80",
    },
    {
      name: "Website Design & Hosting",
      price: "From UGX 1,200,000",
      description:
        "Custom website design, domain registration, hosting, and maintenance.",
      icon: <FaGlobe className="w-10 h-10 text-purple-600" />,
      img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
    },
    {
      name: "Stationery & Office Supplies",
      price: "From UGX 5,000",
      description:
        "Paper, inks, toners, pens, notebooks, filing – everything at great prices.",
      icon: <FaClipboardList className="w-10 h-10 text-orange-600" />,
      img: "https://m.media-amazon.com/images/I/81K5l37CaGL.jpg",
    },
    {
      name: "Branding & Design",
      price: "From UGX 350,000",
      description:
        "Logo design, business cards, banners – custom branding for SMEs and corporates.",
      icon: <FaPenFancy className="w-10 h-10 text-pink-600" />,
      img: "https://media.licdn.com/dms/image/v2/D4E12AQE5h7fOUJoqnQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1690827620760?e=2147483647&t=-fWaTqvuEGfAllY3HAgLAEpPhjMWKH_zMLdps3IzZfM&v=beta",
    },
    {
      name: "Industrial Printing",
      price: "From UGX 15,000",
      description:
        "Flyers, brochures, posters, books – e-commerce platform + 5% sponsor discount.",
      icon: <FaPrint className="w-10 h-10 text-red-600" />,
      img: "https://image.made-in-china.com/2f0j00odjthYMCySqO/3-2m-Advertisement-PVC-Banner-Large-Format-Printer.webp",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => setCurrentIndex((i) => (i + 1) % kevmarkProducts.length);
  const prev = () =>
    setCurrentIndex(
      (i) => (i - 1 + kevmarkProducts.length) % kevmarkProducts.length
    );

  useEffect(() => {
    const id = setInterval(next, 4500);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      id="products"
      className="relative py-16 px-6 overflow-hidden"
      style={{ minHeight: "calc(100vh - 80px)" }}
    >
      {/* === SMOOTH BACKGROUND LAYERS === */}
      <div className="absolute inset-0 -z-10">
        {/* Subtle Gradient Base */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-purple-50" />

        {/* Floating Orbs (Blurred & Animated) */}
        <div className="absolute top-10 left-10 w-96 h-96 bg-blue-300 rounded-full filter blur-3xl opacity-20 animate-pulse" />
        <div className="absolute top-32 right-20 w-80 h-80 bg-purple-300 rounded-full filter blur-3xl opacity-15 animate-pulse delay-700" />
        <div className="absolute bottom-20 left-32 w-72 h-72 bg-teal-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-1000" />
        <div className="absolute bottom-10 right-40 w-64 h-64 bg-pink-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-300" />

        {/* Soft Top Fade */}
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-white to-transparent" />
      </div>

      {/* === CONTENT === */}
      <div className="relative z-10">
        {/* Title */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Our Products & Solutions
          </h2>
          <p className="mt-3 text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by schools, businesses, and government since 2008.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative max-w-7xl mx-auto overflow-hidden">
          <div
            className="flex transition-transform duration-600 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 33.333}%)` }}
          >
            {kevmarkProducts.map((p, i) => (
              <div key={i} className="flex-shrink-0 w-1/3 px-4">
                <div className="group bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-white/50">
                  {/* Image */}
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={p.img}
                      alt={p.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition" />
                  </div>

                  {/* Content */}
                  <div className="p-6 text-center">
                    <div className="flex justify-center mb-3">{p.icon}</div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      {p.name}
                    </h3>
                    <p className="mt-2 text-sm text-gray-600 line-clamp-2">
                      {p.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Arrows */}
          <button
            onClick={prev}
            className="absolute left-2 top-1/2 -translate-y-1/2 p-2.5 bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:shadow-xl transition"
            aria-label="Previous product"
          >
            <FaChevronLeft className="w-5 h-5 text-blue-700" />
          </button>
          <button
            onClick={next}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-2.5 bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:shadow-xl transition"
            aria-label="Next product"
          >
            <FaChevronRight className="w-5 h-5 text-blue-700" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center mt-8 space-x-2">
          {kevmarkProducts.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              className={`w-2.5 h-2.5 rounded-full transition ${
                i === currentIndex
                  ? "bg-blue-700 w-8"
                  : "bg-gray-300 hover:bg-gray-400"
              }`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        {/* View All CTA */}
        <div className="text-center mt-12">
          <Link
            to="/all-products"
            className="inline-flex items-center gap-2 bg-blue-700 text-white px-7 py-3.5 rounded-lg font-semibold shadow hover:bg-blue-800 hover:shadow-lg transition"
          >
            View All Products
            <FaChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
// import { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// export function Products() {
//   const products = [
//     {
//       name: "Dell Inspiron 15",
//       price: 2800000, // UGX
//       description: "Powerful and reliable laptop for everyday tasks.",
//       img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Razer BlackWidow V4",
//       price: 680000, // UGX
//       description: "Mechanical gaming keyboard with RGB lighting.",
//       img: "https://images.unsplash.com/photo-1625079737710-3c7dfc915b14?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Logitech MX Master 3",
//       price: 370000, // UGX
//       description: "Ergonomic and precise mouse for productivity.",
//       img: "https://images.unsplash.com/photo-1611078489603-4f42a96d7f4b?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "Samsung T7 Portable SSD",
//       price: 560000, // UGX
//       description: "Fast and compact 1TB external solid-state drive.",
//       img: "https://images.unsplash.com/photo-1616765684238-0e77a46bb5a7?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "BenQ 27-inch Monitor",
//       price: 1110000, // UGX
//       description: "Full HD monitor with eye-care technology.",
//       img: "https://images.unsplash.com/photo-1587202372775-f5b4e9db8693?auto=format&fit=crop&w=800&q=80",
//     },
//     {
//       name: "SteelSeries Arctis 7",
//       price: 560000, // UGX
//       description: "Wireless gaming headset with crystal-clear audio.",
//       img: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?auto=format&fit=crop&w=800&q=80",
//     },
//   ];
//   const [currentProductIndex, setCurrentProductIndex] = useState(0);

//   const nextProduct = () => {
//     setCurrentProductIndex((prevIndex) => (prevIndex + 1) % products.length);
//   };

//   const prevProduct = () => {
//     setCurrentProductIndex(
//       (prevIndex) => (prevIndex - 1 + products.length) % products.length
//     );
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentProductIndex((prevIndex) => (prevIndex + 1) % products.length);
//     }, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   // return (
//   //   <section
//   //     id="products"
//   //     //   className="py-16 px-6 bg-gray-50"
//   //     className="py-16 px-6 bg-blue-600"
//   //     //   className="py-16 px-6 bg-red-400"
//   //     style={{ minHeight: "calc(100vh - 60px)" }}
//   //   >
//   //     <h3 className="text-3xl font-bold text-center mb-12">
//   //       Featured Products
//   //     </h3>

//   //     <div className="max-w-6xl mx-auto relative overflow-hidden">
//   //       {/* Carousel */}
//   //       <div
//   //         className="flex items-center justify-start transition-transform duration-500 ease-in-out"
//   //         style={{
//   //           transform: `translateX(calc(-${
//   //             currentProductIndex * 33.333
//   //           }% + 33.333%))`,
//   //         }}
//   //       >
//   //         {products.map((p, i) => (
//   //           <div
//   //             key={i}
//   //             className={`relative flex-shrink-0 w-1/3 p-4 transition-all duration-500 ease-in-out ${
//   //               i === currentProductIndex
//   //                 ? "opacity-100 scale-105"
//   //                 : "opacity-50 scale-90"
//   //             }`}
//   //           >
//   //             <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
//   //               <img
//   //                 src={p.img}
//   //                 alt={p.name}
//   //                 className="w-full h-48 object-cover"
//   //               />
//   //               <div className="p-6 text-center">
//   //                 <h4 className="text-xl font-semibold mb-1">{p.name}</h4>
//   //                 <p className="text-sm text-gray-500">{p.description}</p>
//   //                 <p className="text-2xl font-bold text-blue-600 mt-3">
//   //                   {p.price}
//   //                 </p>
//   //                 <button className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
//   //                   Add to Cart
//   //                 </button>
//   //               </div>
//   //             </div>
//   //           </div>
//   //         ))}
//   //       </div>

//   //       {/* Left / Right Buttons */}
//   //       <button
//   //         onClick={prevProduct}
//   //         className="absolute top-1/2 -translate-y-1/2 left-0 p-3 rounded-full text-blue-600 bg-white shadow-lg hover:bg-gray-100 transition-colors z-10"
//   //       >
//   //         <svg
//   //           xmlns="http://www.w3.org/2000/svg"
//   //           className="h-6 w-6"
//   //           fill="none"
//   //           viewBox="0 0 24 24"
//   //           stroke="currentColor"
//   //         >
//   //           <path
//   //             strokeLinecap="round"
//   //             strokeLinejoin="round"
//   //             strokeWidth={2}
//   //             d="M15 19l-7-7 7-7"
//   //           />
//   //         </svg>
//   //       </button>

//   //       <button
//   //         onClick={nextProduct}
//   //         className="absolute top-1/2 -translate-y-1/2 right-0 p-3 rounded-full text-blue-600 bg-white shadow-lg hover:bg-gray-100 transition-colors z-10"
//   //       >
//   //         <svg
//   //           xmlns="http://www.w3.org/2000/svg"
//   //           className="h-6 w-6"
//   //           fill="none"
//   //           viewBox="0 0 24 24"
//   //           stroke="currentColor"
//   //         >
//   //           <path
//   //             strokeLinecap="round"
//   //             strokeLinejoin="round"
//   //             strokeWidth={2}
//   //             d="M9 5l7 7-7 7"
//   //           />
//   //         </svg>
//   //       </button>
//   //     </div>

//   //     {/* Dots */}
//   //     <div className="flex justify-center mt-6 space-x-2">
//   //       {products.map((_, i) => (
//   //         <span
//   //           key={i}
//   //           onClick={() => setCurrentProductIndex(i)}
//   //           className={`block w-3 h-3 rounded-full cursor-pointer transition-colors duration-300 ${
//   //             i === currentProductIndex
//   //               ? "bg-blue-600"
//   //               : "bg-gray-300 hover:bg-gray-400"
//   //           }`}
//   //         ></span>
//   //       ))}
//   //     </div>
//   //   </section>
//   // );

//   return (
//     <section
//       id="products"
//       className="py-12 px-4 bg-gray-50 bg-cover bg-center"
//       style={{
//         minHeight: "calc(100vh - 60px)",
//         backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')`,
//       }}
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-10 text-white">
//         Featured Products
//       </h3>

//       <div className="max-w-5xl mx-auto relative overflow-hidden">
//         {/* Carousel */}
//         <div
//           className="flex items-center justify-start transition-transform duration-500 ease-in-out"
//           style={{
//             transform: `translateX(calc(-${
//               currentProductIndex * 33.333
//             }% + 33.333%))`,
//           }}
//         >
//           {products.map((p, i) => (
//             <div
//               key={i}
//               className={`relative flex-shrink-0 w-1/3 p-3 transition-all duration-500 ease-in-out ${
//                 i === currentProductIndex
//                   ? "opacity-100 scale-100"
//                   : "opacity-50 scale-95"
//               }`}
//             >
//               <div className="bg-white rounded-xl shadow-md overflow-hidden">
//                 <img
//                   src={p.img}
//                   alt={p.name}
//                   className="w-full h-36 object-cover"
//                 />
//                 <div className="p-4 text-center">
//                   <h4 className="text-base md:text-lg font-semibold mb-1">
//                     {p.name}
//                   </h4>
//                   <p className="text-xs md:text-sm text-gray-500">
//                     {p.description}
//                   </p>
//                   <p className="text-lg md:text-xl font-bold text-blue-600 mt-2">
//                     {p.price}
//                   </p>
//                   <button className="mt-3 w-full bg-blue-600 text-white py-1.5 rounded-lg hover:bg-blue-700 transition-colors text-sm">
//                     Add to Cart
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Left / Right Buttons */}
//         <button
//           onClick={prevProduct}
//           className="absolute top-1/2 -translate-y-1/2 left-0 p-2 rounded-full text-blue-600 bg-white shadow-md hover:bg-gray-100 transition-colors z-10"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-5 w-5"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M15 19l-7-7 7-7"
//             />
//           </svg>
//         </button>

//         <button
//           onClick={nextProduct}
//           className="absolute top-1/2 -translate-y-1/2 right-0 p-2 rounded-full text-blue-600 bg-white shadow-md hover:bg-gray-100 transition-colors z-10"
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-5 w-5"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9 5l7 7-7 7"
//             />
//           </svg>
//         </button>
//       </div>

//       {/* Dots */}
//       <div className="flex justify-center mt-4 space-x-2">
//         {products.map((_, i) => (
//           <span
//             key={i}
//             onClick={() => setCurrentProductIndex(i)}
//             className={`block w-2.5 h-2.5 rounded-full cursor-pointer transition-colors duration-300 ${
//               i === currentProductIndex
//                 ? "bg-blue-600"
//                 : "bg-gray-300 hover:bg-gray-400"
//             }`}
//           ></span>
//         ))}
//       </div>

//       {/* View All Products Button */}
//       <div className="text-center mt-8">
//         <Link
//           to="/all-products"
//           className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition text-sm md:text-base"
//         >
//           View All Products
//         </Link>
//       </div>
//     </section>
//   );
// }
